import * as React from 'react';
import { FieldArray } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import JobContact from 'af-components/SharedForms/Contacts/ContactWrapper';

import AdditionalBillingInformation from './AdditionalBillingInformation';
import type { OwnProps as AdditionalContactsOwnProps } from './AdditionalContacts';
import AdditionalContacts from './AdditionalContacts';
import JobUpsertFM from '../../../formModel';
import { formSectionClass, formSectionClassColumn8, formSectionClassRow } from '../../../helpers';
import styles from '../../../styles.module.scss';

type Props = {
	formName: string;
	isDisabled: boolean;
};

const ContactsSection: React.FC<Props> = ({ formName, isDisabled }) => {

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Contacts"
				tooltip="A directory of all relevant contacts associated with this job, including customer, site, and billing contact information."
			/>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					Customer Contact
					<JobContact
						className={styles['job-form__contact']}
						contactLabel="Enter Customer Contact"
						disabled={isDisabled}
						fieldName={JobUpsertFM.getAttributeName('customerContact')}
						formName={formName}
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					Site Contact
					<JobContact
						className={styles['job-form__contact']}
						contactLabel="Enter Site Contact"
						disabled={isDisabled}
						fieldName={JobUpsertFM.getAttributeName('siteContact')}
						formName={formName}
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					Billing Contact
					<JobContact
						className={styles['job-form__contact']}
						contactLabel="Enter Billing Contact"
						disabled={isDisabled}
						fieldName={JobUpsertFM.getAttributeName('billingContact')}
						formName={formName}
					/>
				</div>
			</div>
			<AdditionalBillingInformation disabled={isDisabled} />
			<FieldArray<AdditionalContactsOwnProps>
				component={AdditionalContacts}
				disabled={isDisabled}
				formName={formName}
				name={JobUpsertFM.getAttributeName('additionalContacts')}
			/>
		</div>
	);
};

export default React.memo(ContactsSection);
